import { IntervalleOrdonnancementEnfant } from '@pcscol/odf-api-v1-angular';

export enum OperationOrdonnancementEnfant {
    Debut = 'DEBUT',
    Fin = 'FIN',
    Entre = 'ENTRE'
}

export type OrdonnerEnfantRequest =
    | { operation: OperationOrdonnancementEnfant.Debut }
    | { operation: OperationOrdonnancementEnfant.Fin }
    | { operation: OperationOrdonnancementEnfant.Entre; intervalle: IntervalleOrdonnancementEnfant };
